module.exports = __webpack_public_path__ + "static/di-hero-desktop.1b9ba030.webp";